import { Logo } from '@interhyp/platform-navigation';
import { useAuth } from '@interhyp/util-authentication';
import React from 'react';

import { useLogoPath } from '../../hooks/useLogoPath';

export function CompanyLogo() {
  const logoPath = useLogoPath();
  const { client } = useAuth();
  const logoURI = client === 'broker' ? '#' : '/';

  if (!logoPath) {
    return null;
  }

  return <Logo to={logoURI} src={logoPath} />;
}
